import { Schema } from 'mongoose/browser'
import Model from '../lib/Model'

import Coaching from './Coaching'
import Form from './Form'
import Point from './Point'
import Test from './Test'

const FormModel = new Model(Form({ Schema }))
const PointModel = new Model(Point({ Schema }))
const TestModel = new Model(Test({ Schema }))
const CoachingModel = new Model(
  Coaching({
    Schema,
    PointSchema: PointModel.schema,
    FormSchema: FormModel.schema,
  })
)

export default ctx => ({
  Coaching: CoachingModel,
  Form: FormModel,
  Point: PointModel,
  Test: TestModel,
})
